import { defineStore } from 'pinia'

export const qrCodeLogosStore = defineStore('qrCodeLogosStore', {
    state: () => ({
        logos: [],
        loading: false,
    }),
    actions: {
        async uploadNew(file) {
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            let data = new FormData();
            data.append('file', file);
            const response = await axios.post('/api/media/logo', data, config)
            this.logos.push(response.data)

            return response.data
        },

        async init() {
            this.loading = true;
            const response = await axios.get('/api/media/logos')
            this.logos = response.data
            this.loading = false;
        },

        async delete(logo) {
            const response = await axios.delete(`/api/media/${logo.id}`)
            this.logos.splice(
                this.logos.indexOf(logo),
                1
            )
        }
    }
})
